export const KardexIcon = ({ width = 112, height = 156 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 112 156"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="9" y="43" width="95" height="70.9494" rx="16" fill="#525252" />
    <g clipPath="url(#clip0_0_1)">
      <path
        d="M90.3932 76.5039H66.1484C65.192 76.5039 64.4166 77.3863 64.4166 78.4747C64.4166 79.5632 65.192 80.4455 66.1484 80.4455H90.3932C91.3496 80.4455 92.125 79.5632 92.125 78.4747C92.125 77.3863 91.3496 76.5039 90.3932 76.5039Z"
        fill="white"
      />
      <path
        d="M66.1484 71.2483H90.3932C91.3496 71.2483 92.125 70.3659 92.125 69.2775C92.125 68.189 91.3496 67.3066 90.3932 67.3066H66.1484C65.192 67.3066 64.4166 68.189 64.4166 69.2775C64.4166 70.3659 65.192 71.2483 66.1484 71.2483Z"
        fill="white"
      />
      <path
        d="M90.3932 85.7007H66.1484C65.192 85.7007 64.4166 86.5831 64.4166 87.6715C64.4166 88.7599 65.192 89.6423 66.1484 89.6423H90.3932C91.3496 89.6423 92.125 88.7599 92.125 87.6715C92.125 86.5831 91.3496 85.7007 90.3932 85.7007Z"
        fill="white"
      />
    </g>
    <path
      d="M36.7083 62.0513C32.7415 62.0513 29.5258 65.2305 29.5258 69.1522C29.5258 73.074 32.7415 76.2532 36.7083 76.2532C40.675 76.2532 43.8907 73.074 43.8907 69.1522C43.8907 65.2305 40.675 62.0513 36.7083 62.0513Z"
      fill="white"
    />
    <path
      d="M29.047 80.0404C25.0802 80.0404 21.8645 83.2196 21.8645 87.1413V89.3915C21.8645 90.8178 22.91 92.0339 24.3339 92.2637C32.5292 93.5866 40.8873 93.5866 49.0826 92.2637C50.5065 92.0339 51.552 90.8178 51.552 89.3915V87.1413C51.552 83.2196 48.3363 80.0404 44.3695 80.0404H43.7167C43.3633 80.0404 43.0122 80.0956 42.6763 80.2041L41.0185 80.7392C38.2178 81.6434 35.1987 81.6434 32.398 80.7392L30.7402 80.2041C30.4043 80.0956 30.0532 80.0404 29.6998 80.0404H29.047Z"
      fill="white"
    />
  </svg>
);
